
import { SiteListQueryOrderDirectionEnum, SiteListQueryOrderFieldEnum, SiteTypes } from '@rtl/api'
import { mixins, Options, Prop } from 'vue-property-decorator'

import { SiteListPayload } from '../../store'
import Image from '../components/Image.vue'
import NavLink from '../components/NavLink.vue'
import { FetchSiteListMixin } from '../mixins'
import WidgetMixin, { WidgetMeta, widgetMetaFields } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'Csatorna lista',
  fields: {
    ...widgetMetaFields
  }
}

@Options({
  name: 'ChannelListWidget',
  components: {
    Image,
    NavLink
  }
})
export default class ChannelListWidget extends mixins(WidgetMixin, FetchSiteListMixin) {
  @Prop({
    type: Object,
    default: () => ({})
  })
  readonly payload!: Partial<SiteListPayload>

  get siteListPayload (): SiteListPayload {
    return {
      type: SiteTypes.Channel,
      order: [{ field: SiteListQueryOrderFieldEnum.Sequence, direction: SiteListQueryOrderDirectionEnum.Asc }]
    }
  }
}
